import script from "./BeforeAfter.vue?vue&type=script&setup=true&lang=ts"
export * from "./BeforeAfter.vue?vue&type=script&setup=true&lang=ts"

import "./BeforeAfter.vue?vue&type=style&index=0&id=0ff78df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ff78df2"]])

export default __exports__